<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="pi"></a>The Social Life of Books</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half_title.vue?a3a7a0be